import React from 'react'
import {Icon} from '@chakra-ui/react'

const CloudIcon = (props) => {
    return (
        <Icon viewBox="0 0 14 14" fill="transparent" {...props}>
            <path
                d="M10.2083 6.99967C10.553 6.99967 10.8944 7.06757 11.2128 7.19949C11.5313 7.33141 11.8207 7.52477 12.0644 7.76852C12.3082 8.01227 12.5016 8.30165 12.6335 8.62013C12.7654 8.93861 12.8333 9.27995 12.8333 9.62467C12.8333 9.96939 12.7654 10.3107 12.6335 10.6292C12.5016 10.9477 12.3082 11.2371 12.0644 11.4808C11.8207 11.7246 11.5313 11.9179 11.2128 12.0499C10.8944 12.1818 10.553 12.2497 10.2083 12.2497H5.25346C4.49601 12.2503 3.75331 12.0403 3.10839 11.6431C2.46346 11.2459 1.94173 10.6771 1.60154 10.0003C1.26134 9.32358 1.11608 8.56555 1.182 7.81098C1.24792 7.05641 1.52242 6.33504 1.97481 5.72754C2.4272 5.12003 3.03965 4.65032 3.74368 4.37094C4.44772 4.09155 5.21558 4.01349 5.96144 4.14549C6.70729 4.27749 7.40173 4.61434 7.96712 5.11839C8.5325 5.62243 8.94655 6.2738 9.16296 6.99967H10.2083Z"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.7352 5.25031C12.6145 4.90878 12.3907 4.61314 12.0948 4.40417C11.7989 4.19521 11.4455 4.08321 11.0832 4.08364H9.79581C9.59707 3.38142 9.16484 2.76793 8.57047 2.34444C7.9761 1.92094 7.2551 1.71275 6.52647 1.75421C5.79784 1.79567 5.10511 2.08431 4.56262 2.5725C4.02013 3.06068 3.66029 3.71924 3.54248 4.43948"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <line
                opacity="0.1"
                x1="3.6"
                y1="4"
                x2="3.6"
                y2="12"
                stroke="currentColor"
                strokeWidth="1.2"
            />
            <line
                opacity="0.1"
                x1="6.6"
                y1="4"
                x2="6.6"
                y2="12"
                stroke="currentColor"
                strokeWidth="1.2"
            />
            <line
                opacity="0.1"
                x1="9.6"
                y1="7"
                x2="9.6"
                y2="12"
                stroke="currentColor"
                strokeWidth="1.2"
            />
        </Icon>
    )
}

export default CloudIcon
